import script from "./AudienceHistoricSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceHistoricSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceHistoricSkeleton.vue?vue&type=style&index=0&id=67837c0f&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67837c0f"]])

export default __exports__